const mix=(min,max,progress)=>-progress*min+progress*max+min;export{mix};